import { ImagePlus, X } from "lucide-react";
import { useState } from "react";
import type { PostAspectRatio } from "../../shared/types";
import { api } from "../lib/api";

export function Composer({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [caption, setCaption] = useState("");
  const [location, setLocation] = useState("");
  const [aspectRatio, setAspectRatio] = useState<PostAspectRatio>("4:5");
  const [files, setFiles] = useState<File[]>([]);
  const [commentsEnabled, setCommentsEnabled] = useState(true);
  const [status, setStatus] = useState<"idle" | "saving" | "done" | "error">("idle");
  if (!open) return null;

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setStatus("saving");
    try {
      await api.createPost(caption, location, aspectRatio, files, commentsEnabled);
      setStatus("done");
      setCaption("");
      setFiles([]);
      setTimeout(onClose, 700);
    } catch {
      setStatus("error");
    }
  }

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true" aria-label="Create post">
      <form className="composer" onSubmit={(event) => void submit(event)}>
        <header><strong>Post</strong><button type="button" onClick={onClose} aria-label="Close"><X /></button></header>
        <label className="upload-drop">
          <input type="file" accept="image/*,video/*" multiple onChange={(event) => setFiles(Array.from(event.target.files || []).slice(0, 10))} />
          <ImagePlus />
          <span>{files.length ? `${files.length} file${files.length === 1 ? "" : "s"} selected` : "Upload images or video to R2"}</span>
        </label>
        <div className="segmented" aria-label="Post size">
          {(["1:1", "4:5", "9:16"] as const).map((ratio) => <button type="button" className={aspectRatio === ratio ? "selected" : ""} onClick={() => setAspectRatio(ratio)} key={ratio}>{ratio}</button>)}
        </div>
        <textarea value={caption} onChange={(event) => setCaption(event.target.value)} placeholder="Write a caption..." maxLength={2200} />
        <input value={location} onChange={(event) => setLocation(event.target.value)} placeholder="Location" maxLength={120} />
        <label className="check"><input type="checkbox" checked={commentsEnabled} onChange={(event) => setCommentsEnabled(event.target.checked)} /> Comments enabled</label>
        <button className="primary" type="submit" disabled={status === "saving"}>{status === "saving" ? "Publishing..." : "Publish"}</button>
        {status === "done" && <p className="success">Published.</p>}
        {status === "error" && <p className="error">Could not publish. Check development identity mode.</p>}
      </form>
    </div>
  );
}
